import { axiosInstance as axios } from '@/plugins/axios';

type SenEmail = (data: any) => Promise<any>;
const BASE_URL = process.env.NEXT_PUBLIC_SEND_EMAIL_ENDPOINT;
const SUCCESS = 'success';
const FAILED = 'failed';

// 予約追加
const sendEmail: SenEmail = (data: any) => {
  const endpoint = `${BASE_URL}email/send`;

  return axios.post(`${endpoint}`, {
    ...data,
  });
};

/**
 * to send mail mail by template mail id
 * @param templateMailId
 * @param params
 * @returns
 */
export const sendEmailByTemplateMailId = async (templateMailId: string, params: any) => {
  try {
    const url = BASE_URL + 'send-email/' + templateMailId;
    // console.log('BASE_URL :>> ', BASE_URL);
    await axios.put(url, params);
    return SUCCESS;
  } catch (error) {
    //console.log('Send Email Error: ', error);
    return FAILED;
  }
};

export default sendEmail;
